<template>
  <div v-if="visible" class="fixed bottom-0 left-0 right-0 bg-gray-800 text-white p-4 z-50 flex flex-col md:flex-row md:items-center md:justify-between">
    <p class="mb-2 md:mb-0">{{ $t('cookie.message') }}</p>
    <button @click="accept" class="bg-blue-500 text-white px-4 py-2 rounded">{{ $t('cookie.accept') }}</button>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent',
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    if (!localStorage.getItem('cookie-consent')) {
      this.visible = true;
    }
  },
  methods: {
    accept() {
      localStorage.setItem('cookie-consent', 'true');
      this.visible = false;
    },
    open() {
      this.visible = true;
    },
  },
};
</script>
